const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto', style: 'short' });

/** "just now", "5 min. ago", "yesterday", or a date for anything older than a week. */
export function relativeTime(at: number, now = Date.now()): string {
  const s = Math.round((at - now) / 1000);
  const abs = Math.abs(s);
  if (abs < 45) return 'just now';
  if (abs < 3600) return rtf.format(Math.round(s / 60), 'minute');
  if (abs < 86_400) return rtf.format(Math.round(s / 3600), 'hour');
  if (abs < 7 * 86_400) return rtf.format(Math.round(s / 86_400), 'day');
  return new Date(at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function initial(name: string): string {
  return (Array.from(name.trim())[0] ?? '?').toUpperCase();
}

/** A stable soft tint per app or member so they are told apart at a glance (--tint-alpha is per theme). */
export function tint(key: string, strength = 1): string {
  let h = 0;
  for (const ch of key) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return `hsl(${h} 75% 60% / calc(var(--tint-alpha) * ${strength}))`;
}

/** App icons are an emoji or a bundle-relative path (docs/architecture.md §5). */
export function isImageIcon(icon: string): boolean {
  return /[./]/.test(icon) && !/\s/.test(icon);
}

/** Only same-origin app paths are allowed as post-join destinations. */
export function safeAppPath(path: string | null): string | null {
  return path && path.startsWith('/c/') && !path.startsWith('//') ? path : null;
}
